import { Badge } from '@/components/ui/badge';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

interface WithdrawnPacketAlertProps {
  withdrawalJustification?: string | null;
  className?: string;
}

export function WithdrawnPacketAlert({ withdrawalJustification, className = '' }: WithdrawnPacketAlertProps) {
  return (
    <Alert className={`mb-6 ${className}`}>
      <AlertTitle className="flex items-center gap-2">
        <Badge variant="destructive" className="text-sm font-bold">
          WITHDRAWN
        </Badge>
      </AlertTitle>
      {withdrawalJustification && (
        <AlertDescription className="mt-2 text-base">
          {withdrawalJustification}
        </AlertDescription>
      )}
    </Alert>
  );
} 